var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioButtonChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10809_3365)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 7.30769,
    fill: "white",
    stroke: "#009CA7",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10809_3365)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10809_3365)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_10809_3365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 1.83337C5.94004 1.83337 1.83337 5.94004 1.83337 11C1.83337 16.06 5.94004 20.1667 11 20.1667C16.06 20.1667 20.1667 16.06 20.1667 11C20.1667 5.94004 16.06 1.83337 11 1.83337ZM15.2075 6.94837L9.16671 12.9892L6.79254 10.6242L5.50004 11.9167L9.16671 15.5834L16.5 8.25004L15.2075 6.94837Z",
    fill: "#009CA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2075 7.33337L9.16671 13.1983L6.79254 10.9021L5.50004 12.157L9.16671 15.7169L16.5 8.59713L15.2075 7.33337Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10809_3365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10809_3365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10809_3365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_10809_3365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioButtonChecked);
export default __webpack_public_path__ + "static/media/radio_button_checked.038e0ea17f816de79e3f7de41597bc6b.svg";
export { ForwardRef as ReactComponent };